export function emailFormatter(string = "") {
  const replaceSpecialCharacter = string.replace(/[^\w ]/, "");
  const formattedString = replaceSpecialCharacter
    .replace(/\s+/g, "")
    .toLowerCase();
  return formattedString;
}
